var React = require('react');

function VideoPlayCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30","cy":"30","r":"29","fill":"#FFD600","stroke":"#FFD600","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M44 30L23 42.1244L23 17.8756L44 30Z","fill":"#020303","key":1})]);
}

VideoPlayCircle.defaultProps = {"viewBox":"0 0 60 60","fill":"none"};

module.exports = VideoPlayCircle;

VideoPlayCircle.default = VideoPlayCircle;
